<template>
  <div class="field-container">
    <input id="inputPassword" :type="showPassword ? 'text' : 'password'" class="form-control form-control-lg" v-bind:value="value" v-on:input="updateValue($event.target.value)">
    <i class="show-password-toggler fa" :class="showPassword ? 'fa-eye' : 'fa-eye-slash'" aria-hidden="true" @click="toggleShowPassword(this)"></i>
  </div>
</template>

<style lang="scss" scoped>
  .field-container {
    position: relative;
  }
  .show-password-toggler {
    position: absolute;
    right: 1em;
    top: 35%;
    font-size: 13px;
  }
</style>

<script>
  export default {
    data() {
      return {
        showPassword: false
      }
    },
    props: [
     'value'
    ],
    methods: {
      updateValue(value) {
        this.$emit('input', value)
      },
      toggleShowPassword() {
        this.showPassword = !this.showPassword
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PasswordField.vue